exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barcode {\r\n    /* Use the name of the face that is installed, or the one you defined above */\r\n    font-family: 'Code128'; \r\n  }\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/barcode/barcode.component.css
// module id = ../../../../../src/app/logistics-operations/barcode/barcode.component.css
// module chunks = main